import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Copy } from "lucide-react";

export function DuplicateWarning({ name, type, dates, vehicleIds, excludeId }) {
  const [dups, setDups] = useState([]);
  const key = JSON.stringify([name, type, dates, vehicleIds]);

  useEffect(() => {
    const valid = dates.filter(Boolean);
    if (!name.trim() || !type || !valid.length) { setDups([]); return undefined; }
    const t = setTimeout(() => {
      api.post("/services/duplicates", { event_name: name, service_type: type, dates: valid, vehicle_ids: vehicleIds, exclude_id: excludeId || null })
        .then(({ data }) => setDups(data)).catch(() => setDups([]));
    }, 500);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, excludeId]);

  if (!dups.length) return null;
  return (
    <div className="rounded-lg border border-amber-400 bg-amber-50 p-3 text-xs text-amber-900 space-y-1" data-testid="duplicate-warning">
      <p className="font-semibold flex items-center gap-1.5"><Copy className="h-4 w-4" /> Possibile servizio doppio</p>
      {dups.map((d, i) => (
        <p key={i} data-testid={`duplicate-item-${i}`}>«{d.event_name}» del {d.dates.join(", ")}{d.archived ? " (nello storico)" : ""}: stesso nome, tipo, data, ora e mezzo.</p>
      ))}
      <p className="text-amber-800">Puoi salvare comunque se non è un doppione.</p>
    </div>
  );
}
